import React from "react";
import { cn } from "lib/utils";
import { Badge } from "components/ui/badge";

// Card with an uppercase section header and an optional right-aligned count/summary.
export function SectionCard({ title, count, className, children }) {
    return (
        <div
            className={cn(
                "overflow-hidden rounded-lg border border-border bg-card",
                className
            )}
        >
            <h3 className="flex items-center gap-2 border-b border-border px-4 py-3 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                <span>{title}</span>
                {count != null && (
                    <span className="ml-auto font-medium normal-case tracking-normal">
                        {count}
                    </span>
                )}
            </h3>
            <div className="p-4">{children}</div>
        </div>
    );
}

// A label/value definition grid. `items` is [{ label, value }]; entries whose
// value is null/undefined/"" are skipped so absent fields don't render blank rows.
export function DefinitionList({ items }) {
    const rows = items.filter(
        (item) => item.value !== null && item.value !== undefined && item.value !== ""
    );
    return (
        <dl className="grid grid-cols-[minmax(120px,42%)_1fr] gap-x-4 gap-y-1.5">
            {rows.map((item) => (
                <React.Fragment key={item.label}>
                    <dt className="text-sm text-muted-foreground">{item.label}</dt>
                    <dd className={cn("m-0 break-words", item.mono && "font-mono text-[12.5px]")}>
                        {item.value}
                    </dd>
                </React.Fragment>
            ))}
        </dl>
    );
}

// A boolean pill: green dot + text when on, muted when off.
export function FlagPill({ label, value }) {
    return (
        <span
            className={cn(
                "inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-[12.5px]",
                value
                    ? "border-success/40 bg-success/10 text-foreground"
                    : "border-border bg-muted/40 text-muted-foreground"
            )}
        >
            <span
                className={cn(
                    "h-1.5 w-1.5 rounded-full",
                    value ? "bg-success" : "bg-muted-foreground"
                )}
            />
            {label}
        </span>
    );
}

// Maps an encoder/channel state to a Badge variant.
export function StateBadge({ state }) {
    const variant =
        state === "RUNNING" ? "success" : state === "STARTING" ? "warning" : "secondary";
    return <Badge variant={variant}>{state || "UNKNOWN"}</Badge>;
}

export function Yes() {
    return <Badge variant="success">Yes</Badge>;
}
